
import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { ThemeToggle } from './ThemeToggle';
import { useLocation } from 'react-router-dom';

const Navbar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const [isScrolled, setIsScrolled] = useState(pathname.includes('blog'));
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  console.log('Pathname:', pathname);
  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (pathname.includes('blog')) {
        return;
      }
      // Check if the user has scrolled more than 10 pixels
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navItems = [
    { name: t('navItems.about'), href: '#about' },
    { name: t('navItems.services'), href: '#services' },
    // { name: t('navItems.blog'), href: '/blog' },
    { name: t('navItems.contact'), href: '#contact' }
  ];

  return (
    <header
      className={cn(
        'fixed top-0 left-0 w-full z-50 transition-all duration-300 px-8 dark:bg-developer-dark dark:text-white',
        isScrolled 
          ? 'bg-white bg-opacity-95 shadow-sm py-4 dark:bg-developer-dark dark:bg-opacity-90' 
          : 'bg-transparent py-6'
      )}
    >
      <div className="container-custom flex items-center justify-between">
        <a 
          href="/" 
          className={cn(
            "text-xl md:text-2xl font-display font-semibold transition-colors duration-300",
            isScrolled ? "text-developer-dark dark:text-white" : "text-white"
          )}
        >
          Impelatek
        </a>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8">
          {/* Theme Toggle */}
          <ThemeToggle />
          
          {/* Language Switcher */}
          <LanguageSwitcher />
          
          {/* Navigation Links */}
          <nav className="flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className={cn(
                  "transition-colors duration-300 text-sm font-medium",
                  isScrolled
                    ? "text-developer-neutral dark:text-gray-300 hover:text-developer-accent dark:hover:text-developer-accent-light"
                    : "text-white hover:text-gray-200"
                )}
              >
                {item.name}
              </a>
            ))}
          </nav>
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden flex items-center space-x-4">
          <ThemeToggle />
          <button 
            className={cn(
              "focus:outline-none transition-colors duration-300",
              isScrolled ? "text-developer-dark dark:text-white" : "text-white"
            )}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              strokeWidth={1.5} 
              stroke="currentColor" 
              className="w-6 h-6"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                d={isMobileMenuOpen 
                   ? "M6 18L18 6M6 6l12 12" 
                   : "M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5"} 
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white dark:bg-developer-dark dark:text-white">
          <div className="container-custom py-4 flex flex-col space-y-4">
            {/* Mobile Language Switcher */}
            <div className="py-2">
              <LanguageSwitcher />
            </div>
            
            {/* Navigation Items */}
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-developer-neutral dark:text-gray-300 hover:text-developer-accent dark:hover:text-developer-accent-light transition-colors duration-300 block py-2 text-base"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.name}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
